import React, { useState } from 'react';
import SEOHeadNative from '../components/SEOHeadNative';

const MentionsLegales: React.FC = () => {
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);

  const toggleAccordion = (id: string) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };

  const AccordionItem: React.FC<{
    id: string;
    title: string;
    children: React.ReactNode;
    image?: string;
  }> = ({ id, title, children, image }) => {
    const isOpen = openAccordion === id;
    
    return (
      <div className="t-col t-col_8 t-prefix_2">
        <div className="t585__accordion">
          <div className="t585__wrapper">
            <div className="t585__header" style={{borderTop: '1px solid #eee'}}>
              <button 
                type="button"
                className="t585__trigger-button"
                onClick={() => toggleAccordion(id)}
                aria-expanded={isOpen}
              >
                <span className="t585__title t-name t-name_xl">
                  <strong>{title}</strong>
                </span>
                <span className="t585__icon">
                  <span className="t585__lines">
                    <svg role="presentation" focusable="false" width="24px" height="24px" viewBox="0 0 24 24">
                      <g stroke="none" strokeWidth="1px" fill="none" fillRule="evenodd" strokeLinecap="square">
                        <g transform="translate(1.000000, 1.000000)" stroke="#222222">
                          <path d="M0,11 L22,11"></path>
                          {!isOpen && <path d="M11,0 L11,22"></path>}
                        </g>
                      </g>
                    </svg>
                  </span>
                </span>
              </button>
            </div>
            {isOpen && (
              <div className="t585__content">
                <div className="t585__textwrapper">
                  {image && (
                    <img 
                      className="t585__img t-img"
                      src={image}
                      alt=""
                    />
                  )}
                  <div className="t585__text t-descr t-descr_xs">
                    {children}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <SEOHeadNative
        title="Mentions Légales - OZARKSELEC"
        description="Mentions légales du site OZARKSELEC : éditeur, hébergement, propriété intellectuelle, conditions générales de vente et protection des données personnelles."
        keywords="mentions légales, OZARKSELEC, CGV, RGPD, protection des données"
        canonical="/mentions-legales"
      />
      <div id="rec810126598" className="r t-rec t-rec_pt_90 t-rec_pb_90" style={{paddingTop: '90px', paddingBottom: '90px'}}>
        <div className="t585">
          <div className="t-container">
            <AccordionItem 
              id="editeur" 
              title="Éditeur du site :"
              image="/images/tild6466-3435-4632-b362-626330633337__logo_rectif.png"
            >
              <strong>Éditeur du site :</strong><br />
              <ul>
                <li><strong>Nom de l'entreprise :</strong> Ozarkselec</li>
                <li><strong>Statut juridique :</strong> Micro-entreprise</li>
                <li><strong>Adresse du siège social :</strong> 16 Rue de Prayelle, 59271 Viesly, France</li>
                <li><strong>Numéro de téléphone :</strong> 06 30 98 45 78</li>
                <li><strong>Adresse email :</strong> ozarkselec@gmail.com</li>
                <li><strong>Nom du micro-entrepreneur :</strong> BASQUIN Nathan</li>
                <li><strong>Numéro SIRET :</strong> 979885282</li>
              </ul>
            </AccordionItem>

            <AccordionItem id="hebergement" title="Hébergement :">
              <ul>
                <li><strong>Nom de l'hébergeur :</strong> Service d'hébergement web</li>
                <li><strong>Raison sociale :</strong> Hébergement professionnel</li>
              </ul>
            </AccordionItem>

            <AccordionItem id="directeur" title="Directeur de la publication :">
              BASQUIN Nathan
            </AccordionItem>

            <AccordionItem id="cgv" title="Conditions Générales de Vente (CGV) :">
              Veuillez retrouver nos conditions générales de vente à{' '}
              <a href="https://www.ozarkselec.com/cgv" target="_blank" rel="noreferrer noopener">
                cet emplacement
              </a>
            </AccordionItem>

            <AccordionItem id="donnees" title="Protection des données personnelles :">
              Ozarkselec s'engage à ce que la collecte et le traitement de vos données, effectués à partir du site https://ozarkselec.com, soient conformes au règlement général sur la protection des données (RGPD) et à la loi Informatique et Libertés.<br />
              <ul>
                <li><strong>Responsable du traitement :</strong> BASQUIN Nathan</li>
                <li>Vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition de vos données personnelles. Pour exercer ces droits, contactez-nous à l'adresse suivante : ozarkselec@gmail.com</li>
              </ul>
            </AccordionItem>

            <AccordionItem id="propriete" title="Propriété intellectuelle :">
              Tout le contenu du présent site https://ozarkselec.com, incluant, de façon non limitative, les graphismes, images, textes, vidéos, animations, sons, logos, gifs et icônes ainsi que leur mise en forme sont la propriété exclusive de la société Ozarkselec à l'exception des marques, logos ou contenus appartenant à d'autres sociétés partenaires ou auteurs.
            </AccordionItem>

            <AccordionItem id="responsabilite" title="Clause de non-responsabilité :">
              Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement remis à jour, mais peut toutefois contenir des inexactitudes, des omissions ou des lacunes.
            </AccordionItem>

            <div className="t585__border" style={{height: '1px', backgroundColor: '#eee'}}></div>
          </div>
        </div>
      </div>

      <div id="rec810130400" className="r t-rec t-rec_pt_0 t-rec_pb_75" style={{paddingTop: '0px', paddingBottom: '75px', backgroundColor: '#efefef'}}>
        <div className="t117">
          <div className="t-width t-margin_auto t-width_11 t117__mobpadding">
            <div 
              className="t-map-lazyload t117_map"
              style={{
                backgroundColor: 'rgb(229, 227, 223)',
                overflow: 'hidden',
                transform: 'translateZ(0)',
                borderRadius: '20px',
                height: '385px'
              }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                fontSize: '18px',
                color: '#666'
              }}>
                Carte de localisation - OZARKS ELEC<br />
                16 Rue de Prayelle, 59271 Viesly, France
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;